import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DividerModule } from 'primeng/divider';
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BannerComponent } from '../../../components/banner/banner.component';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/state/app.state';
import { ForgotPswDialogComponent } from '../forgot-psw-dialog/forgot-psw-dialog.component';
import { RegisterDialogComponent } from '../register-dialog/register-dialog.component';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { VehicleTypeService } from '../../../services/vehicle-type.service';
import { VehicleType } from '../../add-vehicle-form/vehcle-type.interfaces';
@Component({
  selector: 'app-verify-email-dialog',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    RippleModule,
    DividerModule,
    BannerComponent,
    RegisterDialogComponent,
    ForgotPswDialogComponent,
    LoginDialogComponent
  ],

  templateUrl: './verify-email-dialog.component.html',
  styleUrl: './../auth-dialog-pages.scss'
})
export class VerifyEmailDialogComponent {
  public email!: string;
  constructor(private route: ActivatedRoute, public router: Router,
    private dialogRef: DynamicDialogRef, private store: Store<AppState>, private dialogService: DialogService,
    private vehicleTypeService: VehicleTypeService) {
    this.route.params.pipe(first()).subscribe({
      next: (params: any) => {
        this.email = params.email;
      }
    });
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public openLoginDialog() {

    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(LoginDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      });

    dialogRef.onClose.subscribe((result) => {
      if (result) {
                 /*
        this.router.navigate(['/'], { queryParamsHandling: 'merge', skipLocationChange: true }).then(() => {
          this.router.navigate(['/' + (this.vehicleTypeService.currentVehicleType)], {
            queryParamsHandling: 'merge'
          });
        })
           */
      }
    })
  }

  public openRegisterDialog() {
    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(RegisterDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      });

    dialogRef.onClose.subscribe((result) => {

    })
  }
  public openForgotPasswordDialog() {
    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(ForgotPswDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      });

    dialogRef.onClose.subscribe((result) => {

    })
  }


}
